/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Proxy_Status_Reloading_ProxyInputs */

const en_iconik_proxy_status_reloading_proxy = /** @type {(inputs: Iconik_Proxy_Status_Reloading_ProxyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reloading proxy... please wait a moment.`)
};

const fr_iconik_proxy_status_reloading_proxy = /** @type {(inputs: Iconik_Proxy_Status_Reloading_ProxyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechargement du proxy... veuillez patienter.`)
};

const de_iconik_proxy_status_reloading_proxy = /** @type {(inputs: Iconik_Proxy_Status_Reloading_ProxyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proxy wird neu geladen... bitte warten Sie einen Moment.`)
};

const it_iconik_proxy_status_reloading_proxy = /** @type {(inputs: Iconik_Proxy_Status_Reloading_ProxyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ricaricamento del proxy... attendere un attimo.`)
};

const ru_iconik_proxy_status_reloading_proxy = /** @type {(inputs: Iconik_Proxy_Status_Reloading_ProxyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перезагрузка прокси... пожалуйста, подождите немного.`)
};

const es_iconik_proxy_status_reloading_proxy = /** @type {(inputs: Iconik_Proxy_Status_Reloading_ProxyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recargando proxy... por favor espere un momento.`)
};

const zh_cn2_iconik_proxy_status_reloading_proxy = /** @type {(inputs: Iconik_Proxy_Status_Reloading_ProxyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在加载代理……请稍候。`)
};

const ja_iconik_proxy_status_reloading_proxy = /** @type {(inputs: Iconik_Proxy_Status_Reloading_ProxyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロキシを再読み込みしています...しばらくお待ちください。`)
};

const hi_iconik_proxy_status_reloading_proxy = /** @type {(inputs: Iconik_Proxy_Status_Reloading_ProxyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रॉक्सी रीलोड हो रहा है... कृपया थोड़ी देर प्रतीक्षा करें।`)
};

const pt_pt2_iconik_proxy_status_reloading_proxy = /** @type {(inputs: Iconik_Proxy_Status_Reloading_ProxyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recarregando proxy... aguarde um momento.`)
};

/**
* | output |
* | --- |
* | "Reloading proxy... please wait a moment." |
*
* @param {Iconik_Proxy_Status_Reloading_ProxyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_proxy_status_reloading_proxy = /** @type {((inputs?: Iconik_Proxy_Status_Reloading_ProxyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Proxy_Status_Reloading_ProxyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iconik_proxy_status_reloading_proxy(inputs)
	if (locale === "de") return de_iconik_proxy_status_reloading_proxy(inputs)
	if (locale === "it") return it_iconik_proxy_status_reloading_proxy(inputs)
	if (locale === "ru") return ru_iconik_proxy_status_reloading_proxy(inputs)
	if (locale === "es") return es_iconik_proxy_status_reloading_proxy(inputs)
	if (locale === "zh-CN") return zh_cn2_iconik_proxy_status_reloading_proxy(inputs)
	if (locale === "ja") return ja_iconik_proxy_status_reloading_proxy(inputs)
	if (locale === "hi") return hi_iconik_proxy_status_reloading_proxy(inputs)
	if (locale === "pt-PT") return pt_pt2_iconik_proxy_status_reloading_proxy(inputs)
	return en_iconik_proxy_status_reloading_proxy(inputs)
});